var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9998 2.7513C6.44349 2.7513 2.74984 6.44495 2.74984 11.0013C2.74984 15.5577 6.44349 19.2513 10.9998 19.2513C15.5562 19.2513 19.2498 15.5577 19.2498 11.0013C19.2498 6.44495 15.5562 2.7513 10.9998 2.7513ZM0.916504 11.0013C0.916504 5.43243 5.43097 0.917969 10.9998 0.917969C16.5687 0.917969 21.0832 5.43243 21.0832 11.0013C21.0832 16.5702 16.5687 21.0846 10.9998 21.0846C5.43097 21.0846 0.916504 16.5702 0.916504 11.0013ZM10.9998 10.0846C11.5061 10.0846 11.9165 10.495 11.9165 11.0013V14.668C11.9165 15.1742 11.5061 15.5846 10.9998 15.5846C10.4936 15.5846 10.0832 15.1742 10.0832 14.668V11.0013C10.0832 10.495 10.4936 10.0846 10.9998 10.0846ZM10.9998 6.41797C10.4936 6.41797 10.0832 6.82837 10.0832 7.33464C10.0832 7.8409 10.4936 8.2513 10.9998 8.2513H11.009C11.5153 8.2513 11.9257 7.8409 11.9257 7.33464C11.9257 6.82837 11.5153 6.41797 11.009 6.41797H10.9998Z",
    fill: "#1776B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.e0c23f20e80d68f1a905921bc479c0b2.svg";
export { ForwardRef as ReactComponent };